import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './features/rootReducer';
import { authMiddleware } from './authMiddleware';
import analyticsOverviewStatsReducer from './features/getAnalyticsOverviewStats';
import { toPersistedLoginState } from '../utils/authSession';

// Drops JWTs persisted before the cookie migration and keeps new ones out of localStorage.
const stripLoginJwt = createTransform(toPersistedLoginState, toPersistedLoginState, {
  whitelist: ['loginToken'],
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['loginToken', 'loginTokenCoUser'], // Add 'loginTokenCoUser' to the whitelist
  transforms: [stripLoginJwt],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authMiddleware),
});

const persistor = persistStore(store);

export { store, persistor };
